// Tiny key/value application store. Commands are plain data:
// { op: 'get', key } | { op: 'put', key, value } | { op: 'append', key, value }
export function createKvStore() {
  return {};
}

export function kvApply(store, command) {
  if (command.op === 'get') {
    return { value: store[command.key] };
  }
  if (command.op === 'put') {
    store[command.key] = command.value;
    return { value: command.value };
  }
  if (command.op === 'append') {
    const current = store[command.key] || '';
    store[command.key] = current + command.value;
    return { value: store[command.key] };
  }
  return { error: 'unknown-op' };
}

export function kvSnapshot(store) {
  return { ...store };
}
